import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'
import patient from '../stores/patient'

const TopBar = styled.div`
  background: #fff;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  position: fixed;
  height: 3.5rem;
  width: 100vw;
  font-weight: 300;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  z-index: 100;
`

const Content = styled.div`
  ${props => !props.noPad
    ? `
      width: 90%;
      max-width: 50rem;
      position: absolute;
      z-index: 0;
      left: 50%;
      transform: translate(-50%, 0);
      top: 3.5rem;
      padding: 1.5rem;
      min-height: calc(100vh - 3.5rem);
      display: flex;
      flex-direction: column;
    `
    : `
      width: 100%;
      position: absolute;
      z-index: 0;
      left: 0;
      top: 3.5rem;
      min-height: calc(100vh - 3.5rem);
      display: flex;
      flex-direction: column;
    `
  }
`

const Icon = styled.i`
  font-size: 1.5rem;
  margin-right: 0.5em;
`

const Back = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  position: absolute;
  top: 0;
  left: 1em;
  height: 100%;
  font-size: 0.75em;
`

@observer
export default class TopBarLayout extends Component {
  render() {
    const { title, children, backHref, backText, noPad, contentRef } = this.props

    return (
      <Fragment>
        <TopBar>
          {backHref && <Back href={backHref}>
            <Icon className="fas fa-chevron-left" />
            {backText || 'Back'}
          </Back>}
          {patient.updateScheduled &&
            <Icon className="fas fa-sync fa-spin" />
          }
          {!patient.updateScheduled && !patient.updateError &&
            <Text str={title} />
          }
          {!patient.updateScheduled && patient.updateError &&
            <Icon className="fas fa-exclamation-triangle" />
          }
        </TopBar>
        <Content noPad={noPad} ref={contentRef}>
          {children}
        </Content>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/layouts/TopBarLayout.js